import { getMandateStatus } from 'features/Onboarding/modules/Mandate';
import getMandateErrors from 'features/Onboarding/modules/Mandate/libs/getMandateErrors';

import { State } from '../../machine';
import model from '../../machine/model';
import locales from './locales';
import { GetVerificationStep } from './types';

const getMandateStep: GetVerificationStep = ({ verificationData }) => {
  const { company, companyUser } = verificationData.viewer;

  const status = getMandateStatus({
    isMandatee: companyUser.isMandatee,
    kybDocuments: company.kybDocuments ?? [],
  });

  return {
    errors: getMandateErrors(company.kybDocuments ?? []),
    id: State.MANDATE,
    metadata: {
      event: model.events.GO_MANDATE(),
      iconName: 'file',
      label: locales.mandate,
    },
    status,
  };
};

export default getMandateStep;
